var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessSetupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 117,
    viewBox: "0 0 157 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 88.0781H88.2853V110.373C88.2853 113.686 85.599 116.373 82.2853 116.373H6.99999C3.68629 116.373 1 113.686 1 110.373V88.0781Z",
    fill: "#6BE3A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1348 54.601V47C31.1348 43.6863 33.8211 41 37.1348 41H52.1517C55.4654 41 58.1517 43.6863 58.1517 47V54.601",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 88.1562V110C1 113.314 3.68629 116 7 116H82C85.3137 116 88 113.314 88 110V88.1562M1 88.1562V56C1 52.6863 3.68629 50 7 50H74.5M1 88.1562H54.8571M88 88.1562H54.8571M88 88.1562V83M54.8571 88.1562V93.5C54.8571 96.8137 52.1709 99.5 48.8571 99.5H37.25",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0178 78.7484C98.9233 78.7484 101.501 72.3919 101.905 65.7477C101.972 64.6451 102.86 63.7488 103.964 63.7488H131.155H143.75C144.855 63.7488 145.758 64.6451 145.691 65.7477C145.287 72.3919 142.709 78.7484 134.804 78.7484H91.0178Z",
    fill: "#F2CA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 63.7488V13.25C131.154 12.1454 130.259 11.25 129.154 11.25H82.0709C80.9664 11.25 80.0709 12.1454 80.0709 13.25V67.4987",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0698 29.998V67.4972",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0714 67.497C80.0714 73.8718 84.8148 78.7467 91.0178 78.7467M91.0178 78.7467H134.804C142.709 78.7467 145.287 72.3902 145.691 65.746C145.758 64.6434 144.855 63.7471 143.75 63.7471H103.964C102.86 63.7471 101.972 64.6434 101.905 65.746C101.501 72.3902 98.9233 78.7467 91.0178 78.7467Z",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6623 33.7483H116.555",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6623 48.749H116.555",
    stroke: "#383434",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSetupIcon);
export default __webpack_public_path__ + "static/media/businessSetupIcon.714c902790d2d2298f537f96bfed9374.svg";
export { ForwardRef as ReactComponent };